import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { IScheduleDaypart } from 'src/interfaces';
import { requestCCApi } from 'src/utils';
import { queryKeys } from 'src/utils/queryKeys';

export interface scheduleDaypartsTransaction {
  resource: string;
  method: string;
  id?: number;
  data: Partial<IScheduleDaypart>;
}

export const useCreateOrUpdateScheduleDayparts = () => {
  return useMutation({
    mutationFn: updateOrCreateScheduleDayparts,
    onSuccess: (_, variable) => {
      queryClient.invalidateQueries(
        queryKeys.scheduleDaypartAssemblies.invalidateAll(),
      );
      queryClient.invalidateQueries(queryKeys.scheduleDayparts.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.defaultAssemblies.invalidateAll(),
      );
      queryClient.invalidateQueries(queryKeys.assemblies.invalidateAll());
      queryClient.invalidateQueries(queryKeys.assemblyListing.invalidateAll());
      // clear cache of calendar endpoint under the updated location group
      queryClient.invalidateQueries(
        queryKeys.getCalendarEvents.details([variable.locationGroupId]),
      );
      queryClient.invalidateQueries(
        queryKeys.locationActiveDays.invalidateAll(),
      );
    },
  });
};

export async function updateOrCreateScheduleDayparts({
  payload,
}: {
  payload: scheduleDaypartsTransaction[];
  locationGroupId?: string;
}) {
  const response = await requestCCApi({
    url: `/transaction`,
    method: 'POST',
    data: {
      data: payload,
    },
  });

  return response;
}
